import React, { Component } from "react"
import { SelectField, MenuItem } from "material-ui"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import { grey500 } from "material-ui/styles/colors"
import { EExpenseScheduleTypeEnum } from "../../models"

interface IProps {
    handleSelection: (value: number) => void
    frequency: number
}

interface IState {
    openTooltip: boolean
}

export class FrequencySelector extends Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            openTooltip: false
        }
    }
    render() {
        return (
            <div>
                <SelectField
                    data-intercom-target={"Expenses-Select-Frequency"}
                    floatingLabelText={strings.Frequency}
                    value={this.props.frequency}
                    onChange={(event, key, frequency) => this.props.handleSelection(Number(frequency))}
                    style={{ width: 250 }}
                >
                    {Object.keys(EExpenseScheduleTypeEnum)
                        .filter((x: any) => isNaN(x))
                        .filter(x => EExpenseScheduleTypeEnum[x] === 1 || EExpenseScheduleTypeEnum[x] === 3)
                        .map((key, index) => (
                            <MenuItem key={index} value={EExpenseScheduleTypeEnum[key]} primaryText={key} />
                        ))}
                </SelectField>
                <ToolTip active={this.state.openTooltip} position="right" arrow="center" parent={"#frequency"}>
                    <div style={{ padding: 5, width: 200, overflowY: "auto", maxHeight: 300 }}>
                        <span>{strings.Frequency_Description}</span>
                    </div>
                </ToolTip>
                <i
                    className="fa fa-question-circle"
                    id={"frequency"}
                    style={{ fontSize: 20, color: grey500, margin: 10 }}
                    onMouseEnter={() => this.setState({ openTooltip: true })}
                    onMouseLeave={() => this.setState({ openTooltip: false })}
                />
            </div>
        )
    }
}

export default FrequencySelector
